import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import jwt_decode from "jwt-decode";
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
//import { environment } from 'src/environments/environment';
import{ environment }  from 'src/app/_services/config.service'
//import { Promise } from 'q';

@Injectable({
  providedIn: 'root'
})
export class AwsS3MappingService {

  s3Path: any;
  s3PathText: any;
  s3ApiData: any;
  brokerData: any = {};
  jwtSession: any = {};
  b2cLicense:boolean = false;
  //S3_BUCKEt_API_DOC_URL= environment.S3_BUCKEt_URL;
  S3_BUCKEt_URL = environment.S3_BUCKEt_URL;//'https://bts-vas.s3.ap-south-1.amazonaws.com/odin-connector/market-place/';
  staticData: any;
  urlConfig: any;
  platformData: any;
  termsData: any;
  publisherData:any;

  constructor(private http: HttpClient, private route: ActivatedRoute) {
    console.log("S3 Service Called");
  }

  initializePath(jSession){

    //this.jwtSession = jSession;
    console.log("Org ID is", this.jwtSession.tenantid)

    this.s3Path = this.jwtSession.tenantid + "/urlsConfig.json";
    this.s3PathText = this.jwtSession.tenantid + "/text.json";
    this.s3ApiData = this.jwtSession.tenantid + "/api.json";
  }

  getS3Data(tenantID) {
    if (!this.staticData) {
      let URL = this.S3_BUCKEt_URL + tenantID + "/staticdata.json" + "?t=" + new Date().getTime();

      let promise = new Promise((resolve, reject) => {
        this.http.get(URL).subscribe(data => {
          this.staticData = data;
          resolve(data);
        }, error => {
          reject(error)
        });
      });
      const observable = from(promise);
      return observable;


    } else {
      let promise = new Promise((resolve, reject) => {
        resolve(this.staticData);
      });
      const observable = from(promise);
      return observable
    }

  }

  getS3APIDOC(tenantID) {
    if (!this.urlConfig) {
      let URL = this.S3_BUCKEt_URL + tenantID + "/urlsConfig.json" + "?t=" + new Date().getTime();;

      let promise = new Promise((resolve, reject) => {
        this.http.get(URL).subscribe(data => {
          this.urlConfig = data;
          resolve(data);
        }, error => {
          reject(error)
        });
      });
      const observable = from(promise);
      return observable;
      //return this.http.get(URL)
    }
    else {
      let promise = new Promise((resolve, reject) => {
        resolve(this.urlConfig);
      });
      const observable = from(promise);
      return observable
    }
  }



  getConfigData(tenantID) {
    if (!this.urlConfig) {
      let URL = this.S3_BUCKEt_URL + tenantID + "/urlsConfig.json" + "?t=" + new Date().getTime();;

      let promise = new Promise((resolve, reject) => {
        this.http.get(URL).subscribe(data => {
          this.urlConfig = data;
          resolve(data);
        }, error => {
          reject(error)
        });
      });
      const observable = from(promise);
      return observable;
      //return this.http.get(URL)
    }
    else {
      let promise = new Promise((resolve, reject) => {
        resolve(this.urlConfig);
      });
      const observable = from(promise);
      return observable
    }

  }




  getPlatforms(tenantID) {
    if (!this.platformData) {

      let URL = this.S3_BUCKEt_URL + tenantID + "/ourPlatforms.json" + "?t=" + new Date().getTime();;
      let promise = new Promise((resolve, reject) => {
        this.http.get(URL).subscribe(data => {
          this.platformData = data;
          resolve(data);
        }, error => {
          reject(error)
        });
      });
      const observable = from(promise);
      return observable;
      //return this.http.get(URL);

    } else {
      let promise = new Promise((resolve, reject) => {
        resolve(this.platformData);
      });
      const observable = from(promise);
      return observable
    }

  }


  geTemplateData(tenantID) {
    if (!this.termsData) {

      let URL = this.S3_BUCKEt_URL + tenantID + "/term-condition.json" + "?t=" + new Date().getTime();;
      let promise = new Promise((resolve, reject) => {
        this.http.get(URL).subscribe(data => {
          this.termsData = data;
          resolve(data);
        }, error => {
          reject(error)
        });
      });
      const observable = from(promise);
      return observable;
      //return this.http.get(URL)
    } else {
      let promise = new Promise((resolve, reject) => {
        resolve(this.termsData);
      });
      const observable = from(promise);
      return observable
    }

  }



  getPublisherData(tenantID) {

    let URL = this.S3_BUCKEt_URL + tenantID + "/publisherDetails.json" + "?t=" + new Date().getTime();;

      let promise = new Promise((resolve, reject) => {
        this.http.get(URL).subscribe(data => {
          this.publisherData = data;
          resolve(data);
        }, error => {
          reject(error)
        });
      });
      const observable = from(promise);
      return observable;
    // if (!this.publisherData) {
      
    //   //return this.http.get(URL)
    // }
    // else {
    //   let promise = new Promise((resolve, reject) => {
    //     resolve(this.publisherData);
    //   });
    //   const observable = from(promise);
    //   return observable
    // }
  }

}